import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';
import { AuthUtils } from '../auth.utils';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check(state.url)
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated AND NOT signing out...
                if (!authenticated && !AuthUtils.isSignOutUrl(state.url)) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL = `?redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in${redirectURL}`);
                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
};
